import { PARSEL_SORGULA } from "../constants/requestUrls";
import { postRequest } from "../request";

const parselSorgula = (props) => {
  let data = {};
  if (props !== undefined) data = JSON.stringify(props);
  return postRequest({ url: PARSEL_SORGULA, data });
};

export default parselSorgula;